import React from 'react';
interface NavbarProps {
  openModal: () => void;
}
export function Navbar({
  openModal
}: NavbarProps) {
  return <nav className="fixed top-0 left-0 w-full bg-white/80 backdrop-blur-md flex justify-between items-center px-6 md:px-12 py-6 z-30 transition-colors duration-500 border-b border-charcoal-100" data-id="element-161">
      <a href="/" className="flex items-center hover:opacity-80 transition-opacity" data-id="element-162">
        <img src="https://cdn.magicpatterns.com/uploads/fTMKMcwziqc5vCPyjAKBhC/C14.svg" alt="Caltalk" className="h-10 w-auto" data-id="element-163" />
      </a>
      <button onClick={openModal} className="px-6 py-3 text-sm font-medium rounded-full bg-gradient-coral text-white hover:bg-gradient-coral-hover transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-coral-500/20" data-id="element-164">
        Download Now
      </button>
    </nav>;
}